import React from 'react';
import { Wrapper, Options } from './styled';
import OptionWithIcon from '~/src/components/Presentation/OptionWithIcon';
import Form from '../Form';
import { num2str } from '~/src/helpers/formatter';

const CallToAction = ({ title, buttonText, properties: { speed, price, channels }, textColor, productRequestFormProps, formEmail, productProperties, hostname }) => {
    return (
        <Wrapper>
            <Options>
                {
                    Boolean(speed) &&
                    <OptionWithIcon
                        key='speed'
                        type='speed'
                        value={speed}
                        text='Мбит/с'
                        description='Скорость интернета'
                        textColor={textColor}
                    />
                }
                {
                    Boolean(channels) &&
                    <OptionWithIcon
                        key='channels'
                        type='channels'
                        value={channels}
                        text={num2str(channels, ['ТВ-канал', 'ТВ-канала', 'ТВ-каналов'])}
                        description='Телевидение'
                        textColor={textColor}
                    />
                }
                {
                    productProperties && productProperties.map(option => {
                        return <OptionWithIcon
                            key={option.key}
                            type={option.key}
                            value={option.value}
                            text={num2str(channels, option.unitDeclension)}
                            description={option.alterDescription}
                            textColor={textColor}
                        />;
                    })
                }
                {
                    Boolean(price) &&
                    <OptionWithIcon
                        key='price'
                        type='price'
                        value={<span itemProp='price'>{price}</span>}
                        text='р/мес'
                        description='Стоимость тарифа'
                        textColor={textColor}
                        hostname={hostname}
                    />
                }
            </Options>
            <Form title={title}
                  buttonText={buttonText}
                  textColor={textColor}
                  props={productRequestFormProps}
                  formEmail={formEmail}
            />
        </Wrapper>
    );
};

export default CallToAction;
